import PropTypes from 'prop-types';
import { Box, Tooltip, IconButton, Typography, Select, MenuItem, FormControl } from '@mui/material';
import { useState } from 'react';
import Icon1 from '../images/frame_1.png';
import Icon2 from '../images/frame_2.png';
import Icon3 from '../images/frame_3.png';
import Icon4 from '../images/frame_4.png';
import Icon5 from '../images/frame_5.png';
import Icon6 from '../images/frame_6.png';
import Icon7 from '../images/frame_7.png';
import Icon8 from '../images/frame_8.png';
import Icon9 from '../images/frame_9.png';
import Icon10 from '../images/frame_10.png';
import Icon11 from '../images/frame_11.png';
// import Icon12 from '../images/frame_12.png';
import Icon13 from '../images/frame_13.png';
import Icon14 from '../images/frame_14.png';
import Icon15 from '../images/frame_15.png';
import Icon16 from '../images/frame_16.png';
import Icon17 from '../images/frame_17.png';
import Icon18 from '../images/frame_18.png';
import Icon19 from '../images/frame_19.png';
import Icon20 from '../images/frame_20.png';
import Icon21 from '../images/frame_21.png';
import Icon22 from '../images/frame_22.png';
import Icon23 from '../images/frame_23.png';
import Icon24 from '../images/frame_24.png';
import Icon25 from '../images/frame_25.png';
import Icon26 from '../images/frame_26.png';
import Icon27 from '../images/frame_27.png';
import Icon28 from '../images/joinB.png';
import Icon29 from '../images/lookupB.png';
import Icon30 from '../images/relationB.png';
import FunctionIcon from '../images/functions.png';

export const functionList = [
  {
    id: 'substring',
    icon: Icon1,
    label: 'Substring',
    description:
      'Extracts part of a text field from the start index to before the end index.',
    example: '"Customer001".substring(8, 11) → "001"',
    docsLink: '#',
  },
  {
    id: 'aggregation',
    icon: Icon21,
    label: 'Aggregation',
    description:
      'Aggregates values such as sum, average, etc. over a group of records.',
    example: 'SUM([1,2,3]) → 6',
    docsLink: '#',
  },
  {
    id: 'field_split',
    icon: Icon2,
    label: 'Split',
    description: 'Splits a string into an array using a specified separator.',
    example: '"a,b,c".split(",") → ["a", "b", "c"]',
    docsLink: '#',
  },
  {
    id: 'trim',
    icon: Icon3,
    label: 'Trim',
    description: 'Removes whitespace from both ends of a string.',
    example: '"   hello   ".trim() → "hello"',
    docsLink: '#',
  },
  {
    id: 'remove_special_characters',
    icon: Icon4,
    label: 'Remove Special Characters',
    description:
      'Removes special characters from a string, leaving only letters and numbers.',
    example: '"Cus#tom@er!001".replace(/[^a-zA-Z0-9]/g, "") → "Customer001"',
    docsLink: '#',
  },
  {
    id: 'currency_format',
    icon: Icon15,
    label: 'Currency Format',
    description: 'Formats a number as currency with configurable currency type and decimal places.',
    example: '12345.67 → "₹12,345.67"',
    docsLink: '#',
    config: {
      currencyType: 'INR',
      decimals: 2
    },
  },
  {
    id: 'format_date',
    icon: Icon9,
    label: 'Format Date',
    description: 'Formats a date string or object into a specified format.',
    example: 'formatDate("2023-12-31", "DD/MM/YYYY") → "31/12/2023"',
    docsLink: '#',
  },
  {
    id: 'add_date',
    icon: Icon10,
    label: 'Add Date',
    description: 'Adds a specified number of days, months, or years to a date.',
    example: 'addDate("2023-01-01", 7, "days") → "2023-01-08"',
    docsLink: '#',
  },
  {
    id: 'uppercase',
    icon: Icon5,
    label: 'Upper Case',
    description: 'Converts all letters in a string to uppercase.',
    example: '"hello".toUpperCase() → "HELLO"',
    docsLink: '#',
  },
  {
    id: 'lowercase',
    icon: Icon6,
    label: 'Lower Case',
    description: 'Converts all letters in a string to lowercase.',
    example: '"HELLO".toLowerCase() → "hello"',
    docsLink: '#',
  },
  {
    id: 'length',
    icon: Icon22,
    label: 'Length',
    description: 'Returns the length of a string or array.',
    example: '"Customer001".length → 11',
    docsLink: '#',
  },
  {
    id: 'replace',
    icon: Icon7,
    label: 'Replace',
    description: 'Replaces specified values in a string with another value.',
    example: '"Hello World".replace("World", "Vishal") → "Hello Vishal"',
    docsLink: '#',
  },
  {
    id: 'mean',
    icon: Icon18,
    label: 'Mean',
    description: 'Calculates the average value from a list of numbers.',
    example: 'mean([1,2,3,4]) → 2.5',
    docsLink: '#',
  },
  {
    id: 'median',
    icon: Icon19,
    label: 'Median',
    description: 'Returns the median value from a list of numbers.',
    example: 'median([1,2,3,4,5]) → 3',
    docsLink: '#',
  },
  {
    id: 'mode',
    icon: Icon20,
    label: 'Mode',
    description: 'Returns the most frequently occurring value in a list.',
    example: 'mode([1,2,2,3]) → 2',
    docsLink: '#',
  },
  {
    id: 'to_timestamp',
    icon: Icon11,
    label: 'To Timestamp',
    description: 'Converts a date or string to a Unix timestamp.',
    example: '"2023-01-01" → 1672531200',
    docsLink: '#',
  },
  {
    id: 'extract',
    icon: Icon13,
    label: 'Extract Month/Day',
    description: 'Extracts the month or day from a date string or object.',
    example: 'extractMonth("2023-05-24") → 5',
    docsLink: '#',
  },
  {
    id: 'day_of_week',
    icon: Icon14,
    label: 'Day of Week',
    description: 'Returns the day of the week from a date string or object.',
    example: 'day_of_week("2023-05-24") → "Wednesday"',
    docsLink: '#',
  },
  {
    id: 'padLeftRight',
    icon: Icon23,
    label: 'Pad Left/Right',
    description:
      'Pads a string with characters to a specified length on the left or right.',
    example: '"1".padStart(3, "0") → "001"',
    docsLink: '#',
  },
  {
    id: 'parse_int',
    icon: Icon16,
    label: 'Parse Int',
    description: 'Parses a string and returns an integer.',
    example: 'parseInt("123") → 123',
    docsLink: '#',
  },
  {
    id: 'parse_double',
    icon: Icon17,
    label: 'Parse Double',
    description: 'Parses a string and returns a floating-point number.',
    example: 'parseFloat("123.45") → 123.45',
    docsLink: '#',
  },
  {
    id: 'convert_to_string',
    icon: Icon8,
    label: 'Convert To String',
    description: 'Converts a value to a string.',
    example: 'String(123) → "123"',
    docsLink: '#',
  },
  {
    id: 'decision',
    icon: Icon24,
    label: 'Decision',
    description:
      'Applies logic to choose an output based on a condition (e.g. =, !=, <, >, true/false). Common for branching or mapping values.',
    example: 'IF(age > 18, "Adult", "Minor") → "Adult"',
    docsLink: '#',
  },
  {
    id: 'filter',
    icon: Icon25,
    label: 'Filter',
    description:
      'Filters values or records based on inclusion logic, such as checking if a field includes a substring or value.',
    example:
      '["apple", "banana"].filter(x => x.includes("a")) → ["apple", "banana"]',
    docsLink: '#',
  },
  {
    id: 'datatypeConversion',
    icon: Icon26,
    label: 'Datatype Conversion',
    description:
      'Converts data between types, such as number ↔ string, string ↔ boolean, or string ↔ date.',
    example: '"42" → 42, 100 → "100"',
    docsLink: '#',
  },
  {
  id: 'join',
  icon: Icon28,
  label: 'Join',
  description:
    'If current source field and field record from reference entity if matches it will pass the matched value to target entity',
  example: 'Employee.department_id → Department.name (matched department_id)',
  docsLink: '#',
},

{
  id: 'lookup',
  icon: Icon29,
  label: 'Lookup',
  description:
    'If current source field and field record from reference entity if matches it will pass the selected value to target entity',
  example: 'Employee.Account_id → EmployeeAccount.name (selected record value)',
  docsLink: '#',
},
  {
    id: 'relation',
    icon: Icon30,
    label: 'Relation',
    description:
      'If source relation field matched with desination relation field it will pass the selected value to target entity',
    example: 'if(Account_id.= Account.Account_id) then(selected value) → AccountFeed',
    docsLink: '#',
  },
  {
    id: 'registry',
    icon: Icon27,
    label: 'Registry',
    description: "Dependent entity records will be loaded only if a corresponding registry entry exists in the DB. When the next entity is transferred, the registry is used to match the source record and map it to the destination reference ID",
    example: "data.source (if ref.source exists in DB) → ref.target",
    docsLink: '#',
  },
];

const groupedFunctions = {
  'String Utilities': [
    'substring',
    'field_split',
    'trim',
    'remove_special_characters',
    'uppercase',
    'lowercase',
    'convert_to_string',
    'replace',
  ],
  'Date & Time': [
    'format_date',
    'add_date',
    'to_timestamp',
    'extract',
    'day_of_week',
  ],
  'Number Formatting & Parsing': [
    'currency_format',
    'parse_int',
    'parse_double',
  ],
  'Statistical Functions': ['mean', 'median', 'mode'],
  Utility: [
    'aggregation',
    'padLeftRight',
    'length',
    'decision',
    'filter',
    'datatypeConversion',
    'join',
    'lookup',
    'relation',
    'registry',
  ],
};

const FunctionToolbar = ({ rightSideComponents }) => {

  const [selectedCategory, setSelectedCategory] = useState('String Utilities');

  const handleCategoryChange = (event) => {
    setSelectedCategory(event.target.value);
  };

  const renderFunctionIcon = (func) => {
    return (
      <Tooltip
        key={func.id}
        title={
          <Box>
            <Typography variant="subtitle2" fontWeight={600}>
              {func.label}
            </Typography>
            <Typography variant="body2" sx={{ mt: 0.5, opacity: 0.9 }}>
              {func.description}
            </Typography>
            <Typography
              variant="caption"
              sx={{
                mt: 1,
                display: 'block',
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                padding: '4px 8px',
                borderRadius: 1,
                fontSize: '0.75rem',
                lineHeight: 1.3,
              }}
            >
              {func.example}
            </Typography>
          </Box>
        }
        placement="top"
        componentsProps={{
          tooltip: {
            sx: {
              p: 2,
              borderRadius: 2,
              backgroundColor: '#1f2937',
              minWidth: 250,
              maxWidth: 250,
              boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
              color: '#ffffff',
              '& .MuiTypography-root': {
                color: '#ffffff',
              },
            },
          },
        }}
      >
        <IconButton
          draggable
          onDragStart={(e) => {
            const dragData = {
              type: 'functionNode',
              functionType: func.id,
              icon: func.icon,
            };

            // Add config data for currency_format function
            if (func.id === 'currency_format' && func.config) {
              dragData.config = func.config;
            }

            e.dataTransfer.setData(
              'application/reactflow',
              JSON.stringify(dragData)
            );
            e.dataTransfer.effectAllowed = 'move';
          }}
          sx={{
            width: 32,
            height: 32,
            borderRadius: 1,
            backgroundColor: '#EEF2FF',
            border: '1px solid rgba(40, 41, 43, 0.09)',
            cursor: 'grab',
            transition: 'all 0.2s ease',
            '&:hover': {
              backgroundColor: '#e5e7eb',
              borderColor: '#d1d5db',
              transform: 'translateY(-1px)',
            },
            '&:active': {
              cursor: 'grabbing',
              transform: 'translateY(0px)',
            },
          }}
        >
          <img
            src={func.icon}
            alt={func.label}
            style={{
              width: 16,
              height: 16,
              objectFit: 'contain',
              filter: 'brightness(0) saturate(100%) invert(20%) sepia(100%) saturate(2000%) hue-rotate(220deg) brightness(95%) contrast(95%)',
            }}
          />
        </IconButton>
      </Tooltip>
    );
  };



  return (
    <Box
      sx={{
        width: '100%',
        height: '60px',
        px: 2,
        py: 1,

      }}
    >
      <Box display="flex" alignItems="center" justifyContent="space-between" gap={2}>
        <Box display="flex" alignItems="center" gap={1}>
          {/* Function Icon */}
          <Box
            sx={{
              width: 32,
              height: 32,
              borderRadius: 50,
              backgroundColor: '#EEF2FF',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <img
              src={FunctionIcon}
              alt="Function Icon"
              style={{
                width: 20,
                height: 20,
                objectFit: 'cover',
                filter: 'brightness(0) saturate(100%) invert(20%) sepia(85%) saturate(2000%) hue-rotate(220deg) brightness(95%) contrast(95%)',
              }}
            />
          </Box>

          {/* Functions Library Text */}
          <Typography
            variant="h6"
            fontWeight={600}
            sx={{
              color: '#525252',
              fontWeight: 600,
              fontSize: '1rem',
              letterSpacing: '0.025em',
            }}
          >
            Functions Library
          </Typography>

          {/* Category Dropdown */}
          <FormControl size="small" sx={{ minWidth: 200, ml: 8 }}>
            <Select
              value={selectedCategory}
              onChange={handleCategoryChange}
              displayEmpty
              sx={{
                backgroundColor: '#ffffff',
                border: '1px solid #d1d5db',
                borderRadius: 1,
                height: 36,
                fontSize: '0.875rem',
                '& .MuiSelect-select': {
                  padding: '6px 12px',
                  fontSize: '0.875rem',
                  fontWeight: 500,
                  color: '#374151',
                },
                '&:hover': {
                  borderColor: '#9ca3af',
                },
                '& .MuiOutlinedInput-notchedOutline': {
                  border: 'none',
                },
                '& .MuiSelect-icon': {
                  color: '#6b7280',
                },
              }}
              MenuProps={{
                PaperProps: {
                  sx: {
                    borderRadius: 1,
                    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
                    border: '1px solid #e5e7eb',
                    mt: 0.5,
                    '& .MuiMenuItem-root': {
                      fontSize: '0.875rem',
                      fontWeight: 500,
                      padding: '8px 12px',
                      '&:hover': {
                        backgroundColor: '#f3f4f6',
                      },
                      '&.Mui-selected': {
                        backgroundColor: '#eff6ff',
                        color: '#1d4ed8',
                        fontWeight: 600,
                        '&:hover': {
                          backgroundColor: '#dbeafe',
                        },
                      },
                    },
                  },
                },
              }}
            >
              <MenuItem value="" disabled sx={{ fontStyle: 'italic', color: '#9ca3af' }}>
                Select Category
              </MenuItem>
              {Object.keys(groupedFunctions).map((category) => (
                <MenuItem key={category} value={category}>
                  {category}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          {/* Function Icons */}
          {selectedCategory && (
            <Box
              display="flex"
              gap={1}
              sx={{
                ml: 2,
                maxWidth: '500px',
                overflowX: 'auto',
                '&::-webkit-scrollbar': {
                  height: '4px',
                },
                '&::-webkit-scrollbar-track': {
                  background: '#f3f4f6',
                  borderRadius: '2px',
                },
                '&::-webkit-scrollbar-thumb': {
                  background: '#d1d5db',
                  borderRadius: '2px',
                  '&:hover': {
                    background: '#9ca3af',
                  },
                },
              }}
            >
              {groupedFunctions[selectedCategory].map((funcId) => {
                const func = functionList.find((f) => f.id === funcId);
                return func ? renderFunctionIcon(func) : null;
              })}
            </Box>
          )}
        </Box>

        {/* Right Side Components */}
        {rightSideComponents && (
          <Box display="flex" alignItems="center" gap={2}>
            {rightSideComponents}
          </Box>
        )}
      </Box>
    </Box>
  );
};

FunctionToolbar.propTypes = {
  rightSideComponents: PropTypes.node,
};

export { groupedFunctions };
export default FunctionToolbar;
